import React from 'react';
import {
    BaseEdge,
    EdgeLabelRenderer,
    getStraightPath,
    useReactFlow,
    getBezierPath,
    Position
  } from '@xyflow/react';
  
  export default function CustomEdge({ id, sourceX, sourceY, targetX, targetY, markerEnd, data }) {
    const [edgePath, labelX, labelY] = getBezierPath({
      sourceX,
      sourceY,
      sourcePosition: Position.Right,
      targetX,
      targetY,
      targetPosition: Position.Left,
    });
  
    return (
      <>
        <BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={{strokeWidth: 2, stroke: 'blue',}}/>
        <EdgeLabelRenderer>
          <button
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: 'all',
              border: '1px solid lightgrey',
              fontSize: 20,
              color: 'black',
              zIndex: 1,
              borderRadius:'50%',
              backgroundColor:'lightgrey',
            }}
            className="nodrag nopan"
            onClick={()=> data.deleteEdge(id)}
          >
            ×
          </button>
        </EdgeLabelRenderer>
      </>
    );
  }
  